import React from 'react';
import { FlowDto } from '../interfaces/flow';

interface FlowSelectorProps {
    flujosCatalogo: FlowDto[];
    value: FlowDto | null;
    onChange: (flow: FlowDto) => void;
}

const FlowSelector: React.FC<FlowSelectorProps> = ({ flujosCatalogo, value, onChange }) => {
    return (
        <div className='flow-selector'>
            {flujosCatalogo.map((level) => {
                const isSelected = value && value.id_flujo === level.id_flujo;
                const isActive = value && value.id_flujo >= level.id_flujo;
                return (
                    <div
                        key={level.id_flujo}
                        className={`droplet ${isSelected ? 'selected' : ''} ${isActive ? 'active' : ''}`}
                        onClick={() => onChange(level)}
                        title={level.descripcion}
                    >
                        <span style={{ visibility: 'hidden' }}>•</span>
                    </div>
                );
            })}
        </div>
    );
};

export default FlowSelector;
